export default {
  USER_LOGIN: {
    url: '/api/user/login',
    method: 'post'
  },
  USER_SAVE: {
    url: '/api/user/add',
    method: 'post',
    disableSuccessMsg: false,
    disableErrorMsg: false
  },
  USER_DELETE: {
    url: '/api/user/delete',
    method: 'post',
    disableSuccessMsg: false,
    disableErrorMsg: false
  },
  USER_MODIFYPASSWORD: {
    url: '/api/user/changePassword',
    method: 'post',
    disableSuccessMsg: false,
    disableErrorMsg: false
  },
  USER_CHANGEPASSWORD: {
    url: '/api/user/admin/password_change',
    method: 'post',
    disableSuccessMsg: true,
    disableErrorMsg: true
  },
  USER_LOGINOUT: {
    url: '/api/user/deactivate',
    method: 'post',
    disableSuccessMsg: false,
    disableErrorMsg: false
  },
  QUERY_USER_LIST: {
    url: '/api/user_search',
    method: 'post',
    disableSuccessMsg: true,
    disableErrorMsg: false
  },
  QUERY_ROLE_LIST: {
    url: '/api/roles',
    method: 'get',
    disableSuccessMsg: true,
    disableErrorMsg: false
  },
  OSS_UPLOAD: {
    url: '/oss/api/files/upload',
    method: 'post',
    disableSuccessMsg: true,
    disableErrorMsg: true
  },
  OSS_GET: {
    url: '/oss/api/files/',
    method: 'get',
    disableSuccessMsg: true,
    disableErrorMsg: true
  },
  OSS_DELETE: {
    url: '/oss/api/files/',
    method: 'delete',
    disableSuccessMsg: true,
    disableErrorMsg: true
  },
  OSS_GET_LIST: {
    url: '/oss/api/files',
    method: 'post',
    disableSuccessMsg: true,
    disableErrorMsg: true
  },
  QUERY_MONITORS_LIST: {
    url: '/api/monitors',
    method: 'post',
    disableSuccessMsg: true,
    disableErrorMsg: false
  },
  QUERY_MONITORS_URL: {
    url: '/api/monitor_url',
    method: 'post',
    disableSuccessMsg: true,
    disableErrorMsg: false
  },
  QUERY_APP_LATEST_VERSION: {
    url: '/api/version/latest/public',
    method: 'get',
    disableSuccessMsg: true,
    disableErrorMsg: true
  }
}
